
Greenmile.DataImport = Greenmile.DataImport || {};

Greenmile.DataImport.SeeLogs = (function () {

    function DataImportSeeLogsScreen(item) {

        this.rootEl = document.createElement("div");
        this.rootEl.className = "SeeLogsScreen";
        Greenmile.DataImport.SeeLogs = Greenmile.DataImport.SeeLogs || {};
        this.item = item;

        this.list = new Monet.UI.List();

        Greenmile.DataImport.SeeLogs.pagination  = {
            first: 0,
            max: 51,
            blocked: false,
            canIncrement: true
        };

        this.list.pagination.executePagination = function (list, context) {

            return function () {

                this.loading.setContainerToAppend(list.el.parentNode);
                this.loading.init();
                this.loading.show();

                var firstResult = list.data.length;
                var options = Monet.Grid.Utils.paginationOptions;
                Greenmile.DataImport.SeeLogs.pagination = { first: firstResult, max: options.MAX_RESULT };
                context.getProgressAndErrors(Greenmile.DataImport.SeeLogs.pagination, context.appendDataAndUpdatePagination );

            };
        }(this.list, this);

        this.renderError = function(error) {
            var errorDiv = document.createElement("div");
            var errorIcon = document.createElement("i");
            var errorSpan = document.createElement("span");
            var message = '';

            errorDiv.className = "seelogs-errorItem";
            errorIcon.className = "fa fa-check";
            if (error.line > 0) {
                message = `<strong>${Monet.I18n.getResourcesByKey("line")} ${error.line}</strong>`;
            }
            message = error.messages.reduce(
                (previousValue, currentValue) => (previousValue += `<div>${Monet.I18n.getResourcesByKey(currentValue)}</div>`)
            , message);
            errorSpan.innerHTML = message;
            errorDiv.appendChild(errorIcon);
            errorDiv.appendChild(errorSpan);

            return errorDiv;
        };

        this.renderErrorsList = function (data) {
            if (!this.rootEl.querySelector('.seelogs-errorTitle')){
                const errorsTitle = document.createElement("span");
                errorsTitle.className = "seelogs-errorTitle";
                errorsTitle.innerHTML = Monet.I18n.getResourcesByKey("errors");
                this.rootEl.appendChild(errorsTitle);
            }

            if (this.list.data.length) {
                this.list.data = [];
                this.list.clearList();
            }

            this.list.itemRenderer = this.renderError;

            if(data && data.length) {
                this.list.appendData(data);
            }

            this.rootEl.appendChild(this.list.render());
        };

        this.appendDataAndUpdatePagination = function(data) {

            var dataLength = data.length,
                pagination = Greenmile.DataImport.SeeLogs.pagination;

            this.list.appendData(data);
            this.list.pagination.loading.hide();

            pagination.canIncrement = true;

            if (dataLength > 0 && dataLength < pagination.max) {
                pagination.first += dataLength + 1;
                pagination.canIncrement = false;
            }
        }.bind(this);

        this.setHeaderInfos = function(data, status, errosProcessed) {
            status = status || this.rootEl.querySelector('.status');
            errosProcessed = errosProcessed || this.rootEl.querySelector('.errosProcessed');
            var totalItems = (typeof data.totalItems === 'undefined' ? '-': data.totalItems);

            status.innerHTML = Monet.I18n.getResourcesByKey("DataImport.ProccessedItems") + ": " + (data.processedItems || "0") + " " + Monet.I18n.getResourcesByKey("of") + " " + totalItems;
            errosProcessed.innerHTML = Monet.I18n.getResourcesByKey("DataImport.ProccessedErros") + ": " + (data.errors|| 0);

        }.bind(this);

        this.setIcon = function(data, icon) {
            icon = icon || this.rootEl.querySelector('.textfile-processing-icon');
            if (data.processStatus && data.processStatus === 'COMPLETED' && !data.errors) {
                icon.className = 'textfile-processing-icon gmfont icon-file-success';
            } else if(data.errors) {
                icon.className  = "textfile-processing-icon error fa fa-file";
            }
        }.bind(this);

        this.renderErrors = function (data) {
            const importLog = document.createElement("span");
            const fileInfo = document.createElement("div");
            const icon = document.createElement("i");
            const fileInfoRight = document.createElement("div");
            const fileName = document.createElement("span");
            const status = document.createElement("span");
            const errosProcessed = document.createElement("span");
            const date = document.createElement("span");

            importLog.className = "importLog-title";
            importLog.innerHTML = Monet.I18n.getResourcesByKey("import.log");

            fileInfoRight.className = "importLog-right";
            fileName.className = "importLog-filename";
            fileName.innerHTML = data.fileName;

            status.className = 'status';
            errosProcessed.className = 'errosProcessed';
            fileInfo.className = "importLog-info";
            icon.className = 'textfile-processing-icon fa fa-file';

            this.setHeaderInfos({}, status, errosProcessed);
            this.setIcon(data, icon);

            fileInfo.appendChild(icon);
            fileInfo.appendChild(fileInfoRight);
            fileInfoRight.appendChild(fileName);
            fileInfoRight.appendChild(status);
            fileInfoRight.appendChild(errosProcessed);
            fileInfoRight.appendChild(date);

            this.rootEl.appendChild(importLog);
            this.rootEl.appendChild(fileInfo);
            this.getProgressAndErrors();

        };

        this.getProgressAndErrors = function (pagination, callback) {
            if (!this.previousData || this.previousData.progress.processStatus !== 'COMPLETED') {
                pagination = pagination || Greenmile.DataImport.SeeLogs.pagination;

                const ajax = new Monet.Ajax();
                ajax.url = "/Process/ProgressAndErrors";
                ajax.method = "POST";
                ajax.data = {
                    "firstResult": pagination.first,
                    "maxResults":  pagination.max,
                    "processId": this.item.processId,
                };
                ajax.success = function (data) {
                    if (data) {
                        if (callback) {
                            callback(data.errors);
                        } else if (!this.previousData || this.previousData.errors.length !== data.errors.length || data.progress.processStatus === 'COMPLETED') {
                            this.renderErrorsList(data.errors);
                            this.setHeaderInfos(data.progress);
                            this.setIcon(data.progress);
                        }
                        this.previousData = data;
                    }
                }.bind(this);
                ajax.send();
            }
        };

        this.render = function (tabName, data) {
          this.item = data;
          let container = document.querySelector('#'+tabName);
          container.innerHTML = '';
          container.appendChild(this.rootEl);
          this.renderErrors(data);
        }

    }

    return DataImportSeeLogsScreen;

})();
